<template>
  <div class="sidebar-left">
    <div class="sidebar">
      <div
        class="sidebar-content todo-sidebar"
        :class="{ show: mqShallShowLeftSidebar }"
        @click="$emit('close-left-sidebar')"
      >
        <div class="todo-app-menu">
          <vue-perfect-scrollbar
            :settings="perfectScrollbarSettings"
            class="sidebar-menu-list scroll-area"
          >
            <!-- Filters -->
            <b-list-group class="list-group-filters mt-2">
              <b-list-group-item
                v-for="filter in menuItems"
                :key="filter.title + $route.path"
                :to="filter.route"
                :active="isDynamicRouteActive(filter.route)"
                @click="$emit('close-left-sidebar')"
              >
                <feather-icon :icon="filter.icon" size="18" class="mr-75" />
                <span class="align-text-bottom line-height-1">{{
                  filter.title
                }}</span>
              </b-list-group-item>
            </b-list-group>
          </vue-perfect-scrollbar>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { BButton, BListGroup, BListGroupItem } from "bootstrap-vue";
import { isDynamicRouteActive } from "@core/utils/utils";
import Ripple from "vue-ripple-directive";

export default {
  directives: {
    Ripple,
  },
  components: {
    BButton,
    BListGroup,
    BListGroupItem,
    VuePerfectScrollbar,
  },
  props: {
    mqShallShowLeftSidebar: {
      type: Boolean,
      required: true,
    },
  },
  setup() {
    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
    };

    const menuItems = [
      {
        title: "Dados gerais",
        icon: "FileTextIcon",
        route: { name: "consultant-details-summary" },
      },
      {
        title: "Empresa e franquia",
        icon: "ArchiveIcon",
        route: { name: "consultant-company-summary" },
      },
      {
        title: "Rede",
        icon: "ChevronsUpIcon",
        route: { name: "consultant-network-summary" },
      },
      {
        title: "Certificados",
        icon: "AwardIcon",
        route: { name: "consultant-certificates" },
      },
      {
        title: "Progressão de nível",
        icon: "ArrowUpRightIcon",
        route: { name: "consultant-roles-history" },
      },
      {
        title: "Promoção de franqueado",
        icon: "TrendingUpIcon",
        route: { name: "lead-pn-promotions" },
      },
      {
        title: "Histórico de escritório",
        icon: "MapPinIcon",
        route: { name: "consultant-physical-franchise-history" },
      },
    ];

    return {
      perfectScrollbarSettings,
      menuItems,
      isDynamicRouteActive,
    };
  },
};
</script>
